module.exports = __webpack_public_path__ + "img/liberado.c368c99e.png";